@let activeType = widget()?.settings?.options?.postTrading?.activeType;

@if (activeType === postTradingEventTypeEnum.EXERCISES) {
	<app-dropdown-columns-actions
		[columns]="exercisesColumns()"
		[translationPrefix]="'postTrading.'"
		(columnsChange)="onChangeExercisesColumns($event)"
	/>
} @else if (activeType === postTradingEventTypeEnum.ASSIGNED) {
	<app-dropdown-columns-actions
		[columns]="assignedColumns()"
		[translationPrefix]="'postTrading.'"
		(columnsChange)="onChangeAssignedColumns($event)"
	/>
} @else if (activeType === postTradingEventTypeEnum.EXPIRED) {
	<app-dropdown-columns-actions
		[columns]="expiredColumns()"
		[translationPrefix]="'postTrading.'"
		(columnsChange)="onChangeExpiredColumns($event)"
	/>
}
